import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../../stem-core/src/ui/Style.js";

import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {Messages} from "../../Messages.js";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {Flow} from "../initializeFlows.js";
import {DonationStore} from "../../../client/state/DonationStore.js";
import {styleRule} from "../../../stem-core/src/ui/Style.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {PayWithAddedCardComponent} from "../pages/panels/payment-method/components/PayWithAddedCardComponent.jsx";


class EditAddCardPanelStyle extends StyleSheet {
    @styleRule
    back = this.themeProps.PANEL_LINK;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };
}

@registerStyle(EditAddCardPanelStyle)
export class EditAddCardPanel extends UI.Element {
    getDonation() {
        return iFrameUserDataService.getActiveRecurringDonation();
    }

    render() {
        const {styleSheet} = this;

        return [
            <PayWithAddedCardComponent ref="cardComponent" onChange={() => this.redraw()}
                                                 title={Messages.updatePaymentMethod}/>,
            <MerchantButton disabled={!this.cardComponent?.isValid()}
                            onClick={() => this.continue()}>
                {Messages.addNewCard}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.back} className={styleSheet.back}
                      onClick={() => this.options.changeURL(DONATE_PAGE_URLS.editChooseCard)}/>
            </div>,
            <PoweredByBlink/>
        ];
    }

    continue() {
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(PaymentMethodStore.Scope.PRIVATE, preferredPaymentMethodId => {
            Flow.donation.updateEditDonationPaymentMethod(PaymentMethodStore.get(preferredPaymentMethodId));
            LoadingSpinner.hide();
            this.options.changeURL(DONATE_PAGE_URLS.editChooseCard, true);
        }, () => {
            // Error rendering is done in the card component.
            LoadingSpinner.hide();
        });
    }

    onMount() {
        this.attachChangeListener(DonationStore, () => {
            if (this.isInDocument() && !this.getDonation()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
